import { useParams, useNavigate } from "react-router-dom";
import { getJobStatus } from "../api/quontxApi";
import { useEffect, useState, useCallback } from "react";

const JobDetailPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const [loadingData, setLoadingData] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const [jobStatus, setJobStatus] = useState();

  const handleBackClick = () => {
    navigate("/jobs");
  };

  const loadJobStatus = useCallback(async () => {
    try {
      const jobStatus = await getJobStatus(jobId);
      setJobStatus(jobStatus.data);
      setErrorMsg(""); // Clear any previous errors
    } catch (error) {
      setErrorMsg("Failed to load job information");
      console.error("Error loading job status:", error);
    }
  }, [jobId]);

  useEffect(() => {
    (async () => {
      setLoadingData(true);
      await loadJobStatus();
      setLoadingData(false);
    })();
  }, [loadJobStatus]);

  if (loadingData)
    return <div className="text-center p-8">Loading job information...</div>;
  if (errorMsg)
    return <div className="text-center p-8 text-red-400">{errorMsg}</div>;

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      {/* Back Button */}
      <button
        onClick={handleBackClick}
        className="mb-4 py-2 bg-qtx-darker text-white rounded hover:bg-qtx-dark transition-colors"
      >
        Back to jobs
      </button>
      <h1 className="text-3xl font-bold text-white mb-2">Job</h1>
      {jobStatus && (
        <div>
          <p className="text-qtx-light-gray mb-6">ID: {jobStatus.uuid}</p>
          <p className="text-qtx-light-gray mb-6">
            Started at:{" "}
            <span className="font-mono bg-qtx-dark px-2 py-1 rounded">
              {jobStatus.started_at}
            </span>
          </p>
          <p className="text-qtx-light-gray mb-6">
            Finished at:{" "}
            <span className="font-mono bg-qtx-dark px-2 py-1 rounded">
              {jobStatus.finished_at}
            </span>
          </p>
          <p className="text-qtx-light-gray mb-6">
            Started by: {jobStatus.user.name}
          </p>
          <p className="text-qtx-light-gray mb-6">Status: {jobStatus.state}</p>
          {jobStatus.error && (
            <p className="text-qtx-light-gray mb-6">Error: {jobStatus.error}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default JobDetailPage;